import { CurrencyModel } from 'models/Settings/Financial/CurrencyModel';
import { ReservationCardGroupModel } from 'pages/ReservationModule/pages/CreateReservationPageNew/models';
import { exportFileTypes } from '../../../../../models/exportFileTypes';

export interface ForecastByRoomTypeReportFormModel {
  from: string | null;
  to: string | null;
  company: ReservationCardGroupModel | null;
  rates: Array<number>;
  roomTypeIds: number[] | null;
  gross_revenue: boolean;
  with_revenue: boolean;
  currency: CurrencyModel | null;
  currency_application: CurrencyApplicationEnum | null;
  fixed_at: string | null;
  sub_filter: SubFilterEnum;
  file_type: exportFileTypes;
  columns: string[];
}

export enum CurrencyApplicationEnum {
  FIXED = 'fixed',
  DAILY = 'daily',
}

export enum SubFilterEnum {
  NONE = 'none',
  ALLOCATION = 'allocation',
  GUARANTEE = 'guarantee',
}
